import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  type?: string;
  noindex?: boolean;
}

const SEO: React.FC<SEOProps> = ({
  title = 'Seoro - Grow Organic Traffic Automatically',
  description = 'Grow organic traffic automatically with Seoro. Generate 30 SEO-optimized articles monthly, get 10 premium backlinks (DA 70+), and track real performance—all in one platform. Stop juggling SEO tools. Start ranking.',
  keywords = 'SEO content automation, AI content generation, premium backlinks, SEO tools, content marketing, organic traffic growth, SEO platform, automated SEO, content creation, backlink building, Google Search Console, WordPress SEO, Shopify SEO, Webflow SEO, AI writing, SEO optimization',
  image = 'https://ancujowsxivyfnxhnsmr.supabase.co/storage/v1/object/public/images/Untitled-222.png',
  type = 'website',
  noindex = false
}) => {
  const location = useLocation();
  const canonicalUrl = `https://seoro.so${location.pathname}`;

  useEffect(() => {
    // Update document title
    document.title = title;

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement;
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.content = content;
    };

    // Update description
    updateMetaTag('description', description);
    updateMetaTag('og:description', description, true);
    updateMetaTag('twitter:description', description);

    // Update title
    updateMetaTag('og:title', title, true);
    updateMetaTag('twitter:title', title);

    // Update image
    updateMetaTag('og:image', image, true);
    updateMetaTag('twitter:image', image);

    // Update URL
    updateMetaTag('og:url', canonicalUrl, true);
    updateMetaTag('twitter:url', canonicalUrl);

    // Update type
    updateMetaTag('og:type', type, true);

    // Update keywords
    updateMetaTag('keywords', keywords);

    // Update robots
    updateMetaTag('robots', noindex ? 'noindex, nofollow' : 'index, follow');

    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = canonicalUrl;

  }, [title, description, keywords, image, type, noindex, canonicalUrl]);

  return null;
};

export default SEO;

